
import {
    CLEAR,
    CHANGE_VIEW,
    INIT_PROJECT,
    REQUEST_GET_INFO,
    RESPONSE_GET_INFO,
    //REQUEST_GET_LEGEND,
    RESPONSE_GET_LEGEND,
    SET_LAYER_VISIBILITY,
    SET_MAP_POINTS
} from '../actions/Map';

const initialState = {
    definition: null,
    center: null,
    rotation: null,
    zoom: null,
    layers: [],
    groups: [],
    foundObjects: null,
    points: [],
    legend: ''
};

function getGroups(project) {
    return project.virtualLayerGroups.map(item => {
        return {
            ...item
        };
    });
}

function getLayers(project) {
    return project.virtualLayers.map(item => {
        return {
            ...item,
            visible: (project.defaultVisibleLayers.indexOf(item.id) !== -1)
        };
    });
}

function setLayerVisibility(layers, id, visible) {
    let changeBaseLayer = layers.reduce((previous, current) => {
        return (current.id === id)
            ? (current.base === true)
            : previous;
    }, false);

    if (changeBaseLayer) {
        return layers.map(item => {
            if (item.id === id) {
                return {
                    ...item,
                    visible: visible
                };
            } else {
                if (item.base === true) {
                    return {
                        ...item,
                        visible: false
                    };
                } else {
                    return item;
                }
            }
        });
    } else {

    }

    return layers.map(item => {
        if (item.base === true) {

        } else {

        }

        return (item.id === id)
            ? {
                ...item,
                visible: visible
            }
            : {
                ...item
            };
    });
}

export default function map(state = initialState, action) {
    switch (action.type) {

        case CLEAR:
            return {
                ...state,
                foundObjects: null,
                points: []
            };

        case CHANGE_VIEW:
            return {
                ...state,
                center: action.center || state.center,
                zoom: action.zoom || state.zoom,
                rotation: action.rotation || state.rotation
            };

        case INIT_PROJECT:
            return {
                ...state,
                definition: action.project,
                center: action.project.center,
                rotation: action.project.rotation || 0,
                zoom: action.project.zoom,
                layers: getLayers(action.project),
                groups: getGroups(action.project)
            };

        case REQUEST_GET_INFO:
            return {
                ...state,
                foundObjects: {
                    data: null,
                    loading: true
                }
            };

        case RESPONSE_GET_INFO:
            return {
                ...state,
                foundObjects: {
                    data: action.data.findResults,
                    loading: false
                },
                points: []
            };

        case RESPONSE_GET_LEGEND:
            return {
                ...state,
                legend: action.data
            };

        case SET_LAYER_VISIBILITY:
            return {
                ...state,
               layers: setLayerVisibility(state.layers, action.id, action.visibility)
            };

        case SET_MAP_POINTS:
            return {
                ...state,
                foundObjects: null,
                points: action.points
            };

        default:
            return state
    }
}
